import { observable, computed, action } from 'mobx'
import { has } from 'lodash'

import RecordStore from 'stores/record/RecordStore'
import Record from 'stores/record/Record'
import SessionStore from './SessionStore'
import Session from './Session'

export interface ISessionSelectionTableCreatePayload {
  sessionId: string
  selectedRecordIds: string[]
}

class SessionSelectionTable {
  @observable sessionId: string
  @observable selectedRecordIds: string[]

  constructor(selection: ISessionSelectionTableCreatePayload) {
    this.sessionId = selection.sessionId
    this.selectedRecordIds = []
  }

  @computed
  private get session(): Session | null {
    return SessionStore.get(this.sessionId)
  }

  @computed
  get maxRows() {
    return this.session?.script?.recordIds.length || 0
  }

  @computed
  get maxColumns() {
    return this.session?.script?.fieldIds.length || 0
  }

  @computed
  get selectedRecords(): Record[] {
    return this.selectedRecordIds.map(rId => RecordStore.get(rId)!)
  }

  @action
  update = (selection: Partial<ISessionSelectionTableCreatePayload>) => {
    has(selection, 'selectedRecordIds') &&
      (this.selectedRecordIds = selection.selectedRecordIds!)
  }
}

export default SessionSelectionTable
